import { Buffer } from 'buffer'

import axiosConfig from '@lib/axiosConfig';


export const OmbudsmanTypeService = {

    list: async function () {
        return await axiosConfig.get('/ombudsman-types');
    },

    show: async function (id) {
        return await axiosConfig.get(`/ombudsman-types/show/${id}`);
    },

    fetchbyfilter: async function (filter, order=null, limit=null) {
        return await axiosConfig.get(`/ombudsman-types/fetchbyfilter/${filter}/${order}/${limit}`);
    },

    store: async function (data) {
        return await axiosConfig.post('/ombudsman-types/store', data);
    },

    update: async function (data, id) {
        return await axiosConfig.put(`/ombudsman-types/update/${id}`, data);
    },

    delete: async function (id) {
        return await axiosConfig.delete(`/ombudsman-types/delete/${id}`);
    }
};